<div class="circle {{ backgroundColorClass }} d-flex justify-content-center align-items-center">
  <i class="icon icon-check icon-64 {{ foregroundColorClass }}"></i>
</div>
